import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServerSentEventService {
  constructor() {}
  getEventSource(url: string): EventSource {
    return new EventSource(url);
  }
  public eventSource: EventSource;

  getServerSentEvent(url: string) {
    return Observable.create((observer) => {
      this.eventSource = this.getEventSource(url);
      this.eventSource.onmessage = (event) => {
        observer.next(event.data);
      };
      this.eventSource.addEventListener('complete', (event) => {
        console.log('on complete event called');
        if (event.eventPhase == this.eventSource.CLOSED) this.eventSource.close();
      });
      this.eventSource.onerror = (error) => {
        if (
          this.eventSource.readyState == this.eventSource.CONNECTING &&
          error.eventPhase == this.eventSource.CLOSED
        ) {
          console.log('Error connecting to server, server may have closed this connection');
          observer.complete();
        } else {
          observer.error(error);
        }
        this.eventSource.close();
      };
      return () => {
        this.eventSource.close();
      };
    });
  }
  closeServerEvent() {
    if (this.eventSource) this.eventSource.close();
  }
}
